import React, { Component } from 'react';
import FullCalendar from '@jacobmischka/ical-merger/dist/components/FullCalendar.js';
import ActiveEvent from '@jacobmischka/ical-merger/dist/components/ActiveEvent.js';
import { getCalendars } from '@jacobmischka/ical-merger/dist/utils.js';
import 'whatwg-fetch';

export default class WidgetCalendar extends Component {
	static defaultProps = {
		calendarId: 'basic',
	};

	constructor() {
		super();

		this.state = {
			GOOGLE_CALENDAR_API_KEY: '',
			calendars: {},
			calendarGroups: {},
			activeEvent: null,
			activeEventElement: null,

			loaded: false,
		};
	}

	componentDidMount() {
		fetch('/.calendar-env.json', {
			mode: 'no-cors',
			cache: 'no-cache',
		})
			.then((response) => {
				if (response.ok) return response.json();

				throw new Error(response.statusText);
			})
			.then((dotenv) => {
				this.setState(Object.assign(dotenv, { loaded: true }));
				if (dotenv.GOOGLE_ANALYTICS_TRACKING_ID && window.ga) {
					window.ga(
						'create',
						dotenv.GOOGLE_ANALYTICS_TRACKING_ID,
						'auto'
					);
					window.ga('send', 'pageview');
				}
			})
			.catch((err) => {
				console.error(err);
			});
	}

	render() {
		if (!this.state.loaded) return null;

		const { calendarId } = this.props;

		const { eventSources } = getCalendars(
			calendarId,
			this.state.calendars,
			this.state.calendarGroups
		);

		if (
			!this.state.GOOGLE_CALENDAR_API_KEY ||
			!eventSources ||
			eventSources.length === 0
		)
			return null;

		return (
			<div>
				<FullCalendar
					apiKey={this.state.GOOGLE_CALENDAR_API_KEY}
					eventSources={eventSources}
					fullcalendarConfig={{
						defaultView: 'listDay',
						header: {
							right: 'today prev,next',
						},
					}}
					setActiveEvent={this.handleSetActiveEvent}
					setActiveEventId={this.handleSetActiveEventId}
				/>
				{this.state.activeEvent && (
					<ActiveEvent
						event={this.state.activeEvent}
						originalElement={this.state.activeEventElement}
						onClose={this.handleUnsetActiveEvent}
					/>
				)}
			</div>
		);
	}

	handleSetActiveEvent = (activeEvent) => {
		this.setState({
			activeEvent,
		});
	};

	handleUnsetActiveEvent = () => {
		this.setState({
			activeEvent: null,
		});
	};

	handleSetActiveEventId = (id, container) => {
		if (container) {
			this.setState({
				activeEventElement: container,
			});
		}
	};
}
